import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * Usage dans les routes :
 *   { path: 'parametres/utilisateurs', canActivate: [permissionGuard],
 *     data: { permissions: ['utilisateurs.gerer'] } }
 */
export const permissionGuard: CanActivateFn = (route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const required = (route.data['permissions'] as string[] | undefined) ?? [];

  // Un signal utilisateur peut rester brièvement en mémoire pendant qu'un
  // intercepteur renouvelle la session. Sans ce contrôle, une navigation en
  // cours peut être prise pour un refus de permission et renvoyée au dashboard.
  if (!auth.isTokenValid()) {
    return router.createUrlTree(['/connexion'], {
      queryParams: { redirect: state.url },
    });
  }

  if (required.length === 0 || auth.hasAnyPermission(required)) {
    return true;
  }

  return router.createUrlTree(['/tableau-de-bord']);
};
